















import { Component, Vue } from "vue-property-decorator";
import { getAuth, Auth } from "firebase/auth";
import {
  collection,
  CollectionReference,
  doc,
  DocumentReference,
  Firestore,
  DocumentSnapshot,
  getDoc,
  getFirestore,
} from "firebase/firestore";
import { app } from "./firebaseConfig";

//Constants
const db: Firestore = getFirestore(app);
const userInfoColl: CollectionReference = collection(db, "users");

@Component({})
export default class App extends Vue {
  uid: string | undefined = "";
  userDoc!: DocumentReference;
  auth: Auth | null = null;
  employeeStatus = false;

  mounted() {
    this.auth = getAuth();
    this.uid = this.auth?.currentUser?.uid;
    this.userDoc = doc(userInfoColl, this.uid);
    this.checkEmployeeStatus();
  }

  updated() {
    this.auth = getAuth();
    this.uid = this.auth?.currentUser?.uid;
    this.userDoc = doc(userInfoColl, this.uid);
    this.checkEmployeeStatus();
  }

  checkEmployeeStatus() {
    getDoc(this.userDoc).then((userData: DocumentSnapshot) => {
      if (userData.exists()) {
        this.employeeStatus = userData.data().userInfo.dotEmployee;
      }
    });
  }
}
